import { render, staticRenderFns } from "./IconSidebarNav.vue?vue&type=template&id=b2561884&"
import script from "./IconSidebarNav.vue?vue&type=script&lang=js&"
export * from "./IconSidebarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports